import React from 'react';

export const TableLineLoader = () => {
  return (
    <div className="progress" role="progressbar">
      <div className="progress-bar bg-primary progress-bar-striped progress-bar-animated w100">chargement</div>
    </div>
  );
}
